
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"3","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill",attrs:{"d":"M1.25 2.932c-.23 0-.438-.056-.628-.168a1.306 1.306 0 01-.454-.454A1.213 1.213 0 010 1.682c0-.231.056-.44.168-.628C.28.864.433.714.622.602c.19-.113.399-.17.628-.17a1.26 1.26 0 011.25 1.25c0 .229-.057.438-.17.628-.112.189-.263.34-.452.454a1.203 1.203 0 01-.628.168zm4.5 0c-.23 0-.438-.056-.628-.168a1.306 1.306 0 01-.454-.454 1.213 1.213 0 01-.168-.628c0-.231.056-.44.168-.628.113-.19.265-.34.454-.452.19-.113.399-.17.628-.17A1.26 1.26 0 017 1.682c0 .229-.057.438-.17.628-.112.189-.263.34-.452.454a1.203 1.203 0 01-.628.168zm4.5 0c-.23 0-.438-.056-.628-.168a1.306 1.306 0 01-.454-.454A1.213 1.213 0 019 1.682c0-.231.056-.44.168-.628.113-.19.265-.34.454-.452.19-.113.399-.17.628-.17a1.259 1.259 0 011.25 1.25c0 .229-.057.438-.17.628-.112.189-.263.34-.452.454a1.203 1.203 0 01-.628.168z","fill":"#459AD6"}})])
          )
        }
      }
    